import { AuthorizedServices } from 'containers/Services'

export default AuthorizedServices
